﻿import { EmployeeDataSection } from '@/common/types/employee-data-permission.def.ts'
import React from 'react'
import { Col, Row } from 'antd'
import { ReportDownloadForm } from '@/common/components/ReportDownloadForm.tsx'
import { AntdForm } from '@/common/components/AntdForm'
import { AntdFormRules } from '@/common/components/AntdForm/rules.tsx'
import {
  useDownloadFundStaffCostReportMutation,
  useDownloadHeadcountPassthroughReportMutation,
  useDownloadSalaryHistoryReportMutation,
} from '@/features/employee-data/employee-data.api.ts'
import { useAuth } from '@/common/hooks/useAuth.ts'
import { integrityCheckErrorColumns, integrityCheckErrorMapper } from '@/utils/integrity-check.ts'

type StaffCostReportDownloadProps = {}

export const StaffCostReportDownload: React.FC<StaffCostReportDownloadProps> = () => {
  const { checkHasAllPermissions } = useAuth()

  return (
    <section>
      <Row gutter={[16, 16]}>
        <Col span={10}>
          <ReportDownloadForm
            title="Fund Staff Cost Report"
            useMutation={useDownloadFundStaffCostReportMutation}
            columnDefs={integrityCheckErrorColumns}
            errorMapper={integrityCheckErrorMapper}
            disabled={!checkHasAllPermissions([{
              moduleName: 'staff-cost',
              functionName: 'download-fund-cost-report',
            }])}
          >
            <AntdForm.DatePicker
              fieldProps={{
                name: 'targetDate',
                rules: [AntdFormRules.required],
              }}
            />
            <AntdForm.ManagedEmploymentEntities
              fieldProps={{ name: 'employmentEntities', rules: [AntdFormRules.required] }}
              targetSections={[EmployeeDataSection.StaffCost]}
            />
          </ReportDownloadForm>
        </Col>
        <Col span={10}>
          <ReportDownloadForm
            title="Salary History Report"
            useMutation={useDownloadSalaryHistoryReportMutation}
            columnDefs={integrityCheckErrorColumns}
            errorMapper={integrityCheckErrorMapper}
            disabled={!checkHasAllPermissions([{
              moduleName: 'staff-cost',
              functionName: 'download-salary-history-report',
            }])}
          >
            <AntdForm.DatePicker
              fieldProps={{
                name: 'targetDate',
                rules: [AntdFormRules.required],
              }}
            />
            <AntdForm.ManagedEmploymentEntities
              fieldProps={{ name: 'employmentEntities', rules: [AntdFormRules.required] }}
              targetSections={[EmployeeDataSection.StaffCost]}
            />
          </ReportDownloadForm>
        </Col>
        <Col span={10}>
          <ReportDownloadForm
            title="Headcount Passthrough Report"
            useMutation={useDownloadHeadcountPassthroughReportMutation}
            columnDefs={integrityCheckErrorColumns}
            errorMapper={integrityCheckErrorMapper}
            disabled={!checkHasAllPermissions([{
              moduleName: 'staff-cost',
              functionName: 'download-headcount-passthrough-report',
            }])}
          >
            <AntdForm.DatePicker
              fieldProps={{
                name: 'targetDate',
                rules: [AntdFormRules.required],
              }}
            />
            <AntdForm.ManagedCountry fieldProps={{ name: 'countries', rules: [AntdFormRules.required] }} />
          </ReportDownloadForm>
        </Col>
      </Row>
    </section>
  )
}